import {SocialBlock} from "./SocialBlock";
import {signUpActions} from "./actions";

export const SocialSignUpBlock = ({redirect}: {redirect?: string}) => {
  return (
    <SocialBlock actions={signUpActions} redirect={redirect}/>
  )
};
